import { render, staticRenderFns } from "./VideosTags.vue?vue&type=template&id=bf6b56b0&"
import script from "./VideosTags.vue?vue&type=script&lang=js&"
export * from "./VideosTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports